export const CATEGORY_KEY: string = 'faq__category';
export const QUESTION_HEADING_KEY: string = 'faq__question-heading';
export const QUESTION_PANEL_KEY: string = 'faq__question-panel';

export const INVITEE_PAGE_STATUS_KEY = 'invitee-page__status';
export const INVITEE_PAGE_DESCRIPTION_KEY = 'invitee-page__description';
export const INVITEE_PAGE_CAMPAIGN_DESCRIPTION_KEY = 'invitation-page__campaign-description';
export const DASHBOARD_PAGE_STATUS_KEY = 'dashboard-page__status';

export const RULES_TRANSLATION_KEYS = [
    INVITEE_PAGE_STATUS_KEY,
    INVITEE_PAGE_DESCRIPTION_KEY,
    INVITEE_PAGE_CAMPAIGN_DESCRIPTION_KEY,
    DASHBOARD_PAGE_STATUS_KEY
];
